/**
 * R4 (Zwischenfeedback) — der Browser-Tab trägt den DATEINAMEN des offenen
 * Dokuments (vorher überall der statische Produktname). Beim Verlassen wird
 * der vorherige Titel wiederhergestellt.
 */
import { useEffect } from "react";

export const useDocumentTitle = (title: string | null | undefined) => {
  useEffect(() => {
    if (!title || typeof document === "undefined") {
      return;
    }
    const prev = document.title;
    document.title = title;
    return () => {
      document.title = prev;
    };
  }, [title]);
};
